// download rows as a CSV file (Excel-friendly: UTF-8 BOM, CRLF, quoted cells).
export interface CsvColumn {
  key: string; // property on the row (dotted paths allowed, e.g. 'bookings.total')
  label: string; // header text
}

function cell(row: any, key: string): string {
  const value = key.split('.').reduce((acc: any, part) => (acc == null ? acc : acc[part]), row);
  if (value === null || value === undefined) return '';
  const text = Array.isArray(value) ? value.join('; ') : String(value);
  return `"${text.replace(/"/g, '""')}"`;
}

export function toCsv(columns: CsvColumn[], rows: any[]): string {
  const header = columns.map((c) => `"${c.label.replace(/"/g, '""')}"`).join(',');
  const lines = rows.map((r) => columns.map((c) => cell(r, c.key)).join(','));
  return '﻿' + [header, ...lines].join('\r\n');
}

export function downloadCsv(fileName: string, columns: CsvColumn[], rows: any[]): void {
  const blob = new Blob([toCsv(columns, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
